import { useEffect, useState } from 'react';

import { fetchPermissions } from './client';
import type { PermissionsState } from './types';

export interface UsePermissionsOptions {
  readonly apiBaseUrl?: string;
  readonly fetchImpl?: typeof fetch;
}

/**
 * โหลดสิทธิ์ของ user ปัจจุบันจาก `GET /v1/me/permissions`
 *
 * - ยกเลิก request อัตโนมัติเมื่อ unmount (AbortController)
 * - ไม่เคย set state เป็นค่าที่แปลว่า "มีสิทธิ์" เมื่อ request ล้มเหลว
 */
export function usePermissions(options: UsePermissionsOptions = {}): PermissionsState {
  const { apiBaseUrl, fetchImpl } = options;
  const [state, setState] = useState<PermissionsState>({ status: 'loading' });

  useEffect(() => {
    const controller = new AbortController();
    let active = true;

    setState({ status: 'loading' });

    void fetchPermissions({
      signal: controller.signal,
      ...(apiBaseUrl === undefined ? {} : { apiBaseUrl }),
      ...(fetchImpl === undefined ? {} : { fetchImpl }),
    }).then((result) => {
      if (!active || result.status === 'cancelled') {
        return;
      }
      setState(result);
    });

    return () => {
      active = false;
      controller.abort();
    };
  }, [apiBaseUrl, fetchImpl]);

  return state;
}
